/**
 * @desc 查看sku销售预测
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuForecastResponseDto>;
export function request(skuNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/getSkuForecast/${skuNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
